import { ChevronStartIcon } from '@fluentui/react-northstar';
import * as React from 'react';

import styles from './index.module.scss';
const CarouselLeftArrow =({ onClick }: {onClick?: () => void}) => {
    return <div className={styles.left} >
        <div onClick={ () => onClick && onClick() }><ChevronStartIcon outline color={'white'} /></div>
    </div>;
};

export default CarouselLeftArrow;